import Axios from 'axios'

import { SERVER_BASE_URL } from './baseUrl'

export const getPortefeuille = async (token: string, userEmail: string, year = 2025) => {
  try {
    const response = await Axios.get(
      `${SERVER_BASE_URL}api/portefeuille?userEmail=${userEmail}&year=${year}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}
